import React from 'react'
import BudgetsRequests from 'src/app/BudgetsRequests/BudgetsRequests'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { budgetsRequestsRouteProps } from 'src/navigation/routeProps'

const BudgetsRequestsAppRoute: AppRoute = {
  routeProps: budgetsRequestsRouteProps,
  component: <BudgetsRequests />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default BudgetsRequestsAppRoute
